module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kc1q3"))).then(() => module.bundle.root('d181N'));